import { api, config } from '../../../helpers/api';

export async function editProfileRequest({
  phone,
  favorites,
  skills,
  wishes,
  about,
  linkedin,
  instagram,
  skype,
  telegram,
  whatsapp,
  gmail,
  birthday,
  show_my_birthday
}) {
  return await api.patch(
    '/user/me',
    {
      phone,
      favorites,
      skills,
      wishes,
      about,
      linkedin,
      instagram,
      skype,
      telegram,
      whatsapp,
      gmail,
      birthday,
      show_my_birthday
    },
    config('json')
  );
}
